module.exports = __webpack_public_path__ + "541b783ffb6baf7e230acd1d0a6736dc.svg";